import React, { useContext } from 'react'
import { withRouter, RouteComponentProps } from 'react-router'

import { routes } from 'constants/routes'
import ToastContext from 'containers/ToastManager/ToastContext'

import {
  CreateWorkspaceProjectMutation,
  GetProjectsDocument,
  useCreateWorkspaceProjectMutation,
} from 'gqlTypes'

import AddNewProjectModal from '../../components/AddNewProjectModal'
import { ModalInjectedProps } from 'containers/ModalManager'

interface AddNewProjectProps extends RouteComponentProps, ModalInjectedProps {
  workspaceId: string
}

const AddNewProject: React.FC<AddNewProjectProps> = props => {
  const { hideModal, history, workspaceId } = props
  const { showToast } = useContext(ToastContext)

  const handleOnComplete = (data: CreateWorkspaceProjectMutation) => {
    const { name, shortId: projectId } = data.createWorkspaceProject.project

    showToast(`"${name}" Project created`)
    history.push(
      routes.WORKSPACE_PROJECT.create({
        projectId,
        workspaceId,
      })
    )

    hideModal()
  }

  // NOTE: At the moment we are not paginating projects
  // and after https://github.com/sketch-hq/cloud-frontend/pull/3298
  // if we ever want to paginate them we might need to re-think the project list
  const [createWorkspaceProject] = useCreateWorkspaceProjectMutation({
    onCompleted: handleOnComplete,
    onError: 'show-toast',
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: GetProjectsDocument,
        variables: { workspaceId },
      },
    ],
  })

  return (
    <AddNewProjectModal
      onSubmit={formValues =>
        createWorkspaceProject({
          variables: {
            projectName: formValues.projectName,
            workspaceId,
          },
        })
      }
      onCancel={hideModal}
    />
  )
}

export default withRouter(AddNewProject)
